import React,{ useState } from 'react';
import useReduxState from "../../../hooks/useReduxState";
import liveAuth from 'src/helper/liveAuth';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useBOMStore } from 'src/hooks/bom';
import CreateProject from 'src/pages/BOM/CreateProject';

const FindBom = (props) => {
    const [{total_bom }, { fetch_bom_project_detail_with_bom }] = useBOMStore();
    const [find_bom_input_bom_listing, set_find_bom_input_bom_listing] = useReduxState('', 'find_bom_input_bom_listing');
    const [search, setSearch] = useState('')
    const [searchClick, setSearchClick] = useState(false)
    const [__check] = useAxiosIndicatorCheck();
    return (
        <>
            <div className="row bs5 m-t-30">
                <div className="col-sm-6">
                    <form onSubmit={async(event) =>{
                        event.preventDefault() ;
                        await fetch_bom_project_detail_with_bom({bomName:search.trim()});
                        set_find_bom_input_bom_listing(search.trim());
                        setSearchClick(true)
                    }} >
                        <div className="d-block d-flex">
                            <input className="ps-2 form-control form-control-sm w200 mb-0" placeholder="Find BOM" type="text"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value)
                                }}
                            />
                            <button className="btn btn-secondary ms-3  bs5 w80">
                                find
                            </button>
                        </div>
                    </form>
                </div>
                {liveAuth.check() && <div className="col-sm-6 text-sm-end mt-3 mt-sm-0">
                    <CreateProject
                        afterBOMCreation={async () => {
                            await fetch_bom_project_detail_with_bom({bomName:search});
                        }}
                    />
                </div>}
            </div>
            {searchClick &&
                <div className="row bs5 mt-4">
                    <span>
                        <div className={total_bom < 1?'mb-3 font-arial text-break':' '}>
                            Results for <strong>"{find_bom_input_bom_listing}"</strong> <a
                                className="text-blue2 ms-1" data-toggle="modal" href={void (0)}
                                onClick={async() => {
                                    await fetch_bom_project_detail_with_bom({bomName:''});
                                    set_find_bom_input_bom_listing('');
                                    setSearch('')
                                    setSearchClick(false)
                                }}
                            >Clear</a>
                        </div>

                        {total_bom < 1 &&
                            <div className="accordion-item">
                                <h2 className="accordion-header mb-1" id="headingOne">
                                    <button className="accordion-button" type="button" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        <b className="font-24">Your BOMs</b>
                                    </button>
                                </h2>
                                <div className='d-flex justify-content-center pb-5 font-arial font-13 text-center text-break px-3'>
                                    Sorry! No Results Found. We can’t find any matches for search term "{find_bom_input_bom_listing}”, please try again.
                                </div>

                            </div>
                        }
                    </span>
                </div>
            }
        </>
    );
}

export default FindBom;